<script setup lang="ts">
import pick from 'lodash/pick'
import type { PropType } from 'vue'
import { useCustomNeedLoginAction } from '~/composables/customNeedLoginAction'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  text: {
    type: Array as PropType<string[]>,
    default: () => ['加入关注', '取消关注'],
  },
  isFavorite: {
    type: [Number, Boolean],
    default: 0,
  },
  sortId: {
    type: Number,
    default: 5,
  },
  numberId: {
    type: Number,
    default: 0,
  },
  dataId: {
    type: Number,
    default: null,
  },
  title: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['likeChange'])

const { handleSaveFavorite, handleDeleteFavorite } = useCustomNeedLoginAction()
const likeTypeField = ['cityId', 'numberId', 'sortId', 'floor', 'averagePrice', 'buildArea', 'dataId', 'houseFrame', 'housePic', 'price', 'rentType', 'title', 'floor']
const { city } = useCityInfoStore()
// 取出必要数据
const like = ref<boolean>((props?.isFavorite === 1) || (props?.isFavorite === true))
// 取出可能存在的数据
const data = pick(props?.data, likeTypeField)
// 组合数据
const params = computed(() => {
  if (props?.dataId) {
    return Object.assign({}, { title: props?.title, cityId: props?.data?.cityId || city, numberId: props?.numberId, source: 1, sortId: props?.sortId, dataId: props?.dataId }, data)
  }
  else {
    return Object.assign({}, { title: props?.title, cityId: props?.data?.cityId || city, numberId: props?.numberId, source: 1, sortId: props?.sortId }, data)
  }
})

const store = useUserInfoStore()

async function handleClick(event: any) {
  event.stopPropagation()
  const userInfo: any = await store.getUserInfo(true)
  if (userInfo?.isLogin) {
    const action = like.value ? cancelLike : toLike
    action()
  }
}

function toLike() {
  handleSaveFavorite(params.value).then((res: any) => {
    if (res.code === 0) {
      emit('likeChange', !like.value ? 1 : 0)
      like.value = !like.value
    }
    else {
      message.error(res.message)
    }
  })
}

// 取消收藏、取消关注
function cancelLike() {
  handleDeleteFavorite(params.value).then((res: any) => {
    if (res.code === 0) {
      emit('likeChange', !like.value ? 1 : 0)
      like.value = !like.value
    }
    else {
      message.error(res.message)
    }
  })
}

/**
 * 抛出此方法用于其他组件修改收藏状态
 * @param val
 */
function setLike(val: number) {
  like.value = val === 1
}

defineExpose({ setLike })
</script>

<template>
  <div class="follow" @click.prevent="handleClick">
    <!--    <HeartFilled v-if="like" style="color: red" /> -->
    <!--    <HeartOutlined v-else /> -->
    <HeartOutlined v-if="like" style="color: #52BE54;" class="icon-style like text-18px" @click.prevent="handleClick" />
    <i v-else class="icon-style iconfont icon-chakantieziguanzhu text-18px" @click.prevent="handleClick" />&nbsp;&nbsp;&nbsp;{{ text[like ? 1 : 0] }}
  </div>
</template>

<style scoped lang="scss">
.follow {
  display: inline-block;
  font-size: 15px;
  color: #3D3D3D;
  margin-right: 10px;
  cursor: pointer;
}
</style>
